var _rect, _circle, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigBindingCoilLongLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 106,
    viewBox: "0 0 88 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 80,
    height: 106,
    rx: 4,
    fill: "#BCBDC0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 53.4443,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.8453 65.333H60.2453V51.533C60.2453 48.133 60.2453 40.733 49.9953 40.733C46.1953 40.733 42.4453 41.883 39.7953 44.583L42.9453 47.733C44.5453 46.233 46.8453 45.233 49.3453 45.233C52.5453 45.233 54.8453 46.783 54.8453 49.733V50.383H53.3453C47.3453 50.383 38.2453 50.933 38.2453 58.733C38.2453 63.483 42.5453 65.933 46.9953 65.933C50.1953 65.933 52.9953 64.733 54.6953 62.033H54.8453V65.333ZM54.4953 55.933C54.4953 59.283 52.5453 61.433 48.4453 61.433C46.4953 61.433 44.2453 60.483 44.2453 58.283C44.2453 54.833 49.9453 54.583 53.2453 54.583H54.4953V55.933Z",
    fill: "#52B3A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.584,
    y: 6.86133,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14.584 6.86133)",
    fill: "#52B3A7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.584,
    y: 16,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14.584 16)",
    fill: "#52B3A7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.584,
    y: 25,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14.584 25)",
    fill: "#52B3A7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.584,
    y: 34,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14.584 34)",
    fill: "#52B3A7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14.584,
    y: 43,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14.584 43)",
    fill: "#52B3A7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14.584,
    y: 52,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14.584 52)",
    fill: "#52B3A7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14.584,
    y: 61,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14.584 61)",
    fill: "#52B3A7"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 14.584,
    y: 70,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14.584 70)",
    fill: "#52B3A7"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 14.584,
    y: 79,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14.584 79)",
    fill: "#52B3A7"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 14.584,
    y: 88,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14.584 88)",
    fill: "#52B3A7"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 14.584,
    y: 97,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 14.584 97)",
    fill: "#52B3A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigBindingCoilLongLeft);
export default __webpack_public_path__ + "static/media/jobconfig-binding-coil-long-left.13d2fc10a01ebec39423b7d2c5da168c.svg";
export { ForwardRef as ReactComponent };